module.exports = __webpack_public_path__ + "MaterialIcons-Regular.570eb83859dc23dd0eec.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/assets/icons/material/MaterialIcons-Regular.woff2
// module id = ../../../../../src/assets/icons/material/MaterialIcons-Regular.woff2
// module chunks = styles